// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardPurseDto
 */
export interface ICardPurseDto {
    /**
     * 
     * @type {number}
     * @memberof ICardPurseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICardPurseDto
     */
    account_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardPurseDto
     */
    account_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardPurseDto
     */
    status?: ICardPurseDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ICardPurseDto
     */
    is_locked_by_health_plan?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICardPurseDto
     */
    is_locked_by_system?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICardPurseDto
     */
    employee_unlock_forbidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICardPurseDto
     */
    lock_reason?: ICardPurseDtoLockReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICardPurseDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN'
}
/**
* @export
* @enum {string}
*/
export enum ICardPurseDtoLockReasonEnum {
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    DOCUMENTATION_REQUIRED = 'DOCUMENTATION_REQUIRED',
    FRAUD_DETECTED = 'FRAUD_DETECTED',
    CARDHOLDERS_REQUEST = 'CARDHOLDERS_REQUEST'
}


/**
 * Check if a given object implements the ICardPurseDto interface.
 */
export function instanceOfICardPurseDto(value: object): value is ICardPurseDto {
    return true;
}

export function ICardPurseDtoFromJSON(json: any): ICardPurseDto {
    return ICardPurseDtoFromJSONTyped(json, false);
}

export function ICardPurseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardPurseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account_name': json['account_name'] == null ? undefined : json['account_name'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'status': json['status'] == null ? undefined : json['status'],
        'is_locked_by_health_plan': json['is_locked_by_health_plan'] == null ? undefined : json['is_locked_by_health_plan'],
        'is_locked_by_system': json['is_locked_by_system'] == null ? undefined : json['is_locked_by_system'],
        'employee_unlock_forbidden': json['employee_unlock_forbidden'] == null ? undefined : json['employee_unlock_forbidden'],
        'lock_reason': json['lock_reason'] == null ? undefined : json['lock_reason'],
    };
}

export function ICardPurseDtoToJSON(json: any): ICardPurseDto {
    return ICardPurseDtoToJSONTyped(json, false);
}

export function ICardPurseDtoToJSONTyped(value?: ICardPurseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account_name': value['account_name'],
        'account_type': value['account_type'],
        'status': value['status'],
        'is_locked_by_health_plan': value['is_locked_by_health_plan'],
        'is_locked_by_system': value['is_locked_by_system'],
        'employee_unlock_forbidden': value['employee_unlock_forbidden'],
        'lock_reason': value['lock_reason'],
    };
}

